module.exports = __webpack_public_path__ + "img/vertical_3_1_3009.22544dc5.png";